import { render, staticRenderFns } from "./ModalQuestion.vue?vue&type=template&id=45f8452a&scoped=true"
import script from "./ModalQuestion.vue?vue&type=script&lang=js"
export * from "./ModalQuestion.vue?vue&type=script&lang=js"
import style0 from "./ModalQuestion.vue?vue&type=style&index=0&id=45f8452a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8452a",
  null
  
)

export default component.exports